import { unwrapAsset } from "../../utils/CockpitUtils";
import Icon from "../Icon";
import BjelinButton from "../BjelinButton";
import axios from "axios";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import prettyBytes from "pretty-bytes";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import "./style.scss";
import ImageOrVideo from "../ImageOrVideo";
import PdfPreview from "../PdfPreview";

const AssetList = ({ type = "small", assets = [], heading = "" }) => {
  const t = useBjelinTranslations();
  const cdnClient = axios.create({ responseType: "blob" });

  assets = assets?.map(item => unwrapAsset(item.value?.asset));
  //console.log("assets", assets);

  const downloadZipFile = async () => {
    const zip = new JSZip();
    try {
      await Promise.all(
        assets.map(async asset => {
          const res = await cdnClient.get(asset.path);
          if (res.data) {
            return zip.file(asset.title, res.data, { binary: true });
          }
        })
      );
      //console.log("zip files:", zip.files);
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, "Bjelin.zip");
    } catch (err) {
      alert(t("error.general"));
    }
  };

  return (
    <div className={`asset-list asset-list-${type}`}>
      {heading && <h3>{heading}</h3>}
      <ul>
        {assets
          .filter(asset => !!asset)
          .map((asset, idx) => {
            let icon;
            if (asset.image) {
              icon = "file-image";
            } else if (asset.video) {
              icon = "file-video";
            } else if (asset.archive) {
              icon = "file-zipper";
            } else if (asset.audio) {
              icon = "file-audio";
            } else {
              icon = "file";
            }
            return (
              <li key={idx}>
                <a href={asset.path} download target="_blank" rel="noreferrer">
                  {type === "small" ? (
                    <>
                      <Icon name={icon} /> {asset.title}{" "}
                      {asset.size && <>({prettyBytes(asset.size)})</>}
                    </>
                  ) : (
                    <>
                      <div className="thumb">
                        {asset.image || asset.video ? (
                          <ImageOrVideo
                            image={asset}
                            centerImage={true}
                            preferredStyles={["thumbnail_large", "medium"]}
                          />
                        ) : asset.mime === "application/pdf" ? (
                          <PdfPreview
                            pdfSrc={asset.path}
                            size={type === "large" ? 500 : 200}
                          />
                        ) : (
                          <div className="thumb-overlay">{asset.title}</div>
                        )}
                        <div className="thumb-overlay thumb-overlay-hover">
                          <Icon name="download" />
                        </div>
                      </div>
                      <div className="label">
                        {asset.title}{" "}
                        {asset.size && <>({prettyBytes(asset.size)})</>}
                      </div>
                    </>
                  )}
                </a>
              </li>
            );
          })}
      </ul>
      <BjelinButton
        color={"secondary"}
        onClick={() => downloadZipFile()}
        icon="download"
        icon_position="before"
      >
        {t("assets.download.all")}
      </BjelinButton>
    </div>
  );
};

export default AssetList;
